import React, { useCallback } from 'react';

import Select from '@atlaskit/select/default';
import { Box } from '@atlaskit/primitives/compiled/box';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

type SelectOption = { value: string; label: string };

const styles = cssMap({
	filterContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.100'),
		marginBlockEnd: token('space.150'),
	},
	selectContainer: {
		minWidth: '12rem',
	},
});

type ContentTypeFilterProps = {
	value: string;
	onChange: (value: string) => void;
	options: SelectOption[];
	filterLabel: string;
};

export function ContentTypeFilter({
	value,
	onChange,
	options,
	filterLabel,
}: ContentTypeFilterProps): React.JSX.Element {
	const selectedOption = options.find((o) => o.value === value) ?? options[0];

	const handleChange = useCallback(
		(option: SelectOption | null) => {
			onChange(option?.value ?? '');
		},
		[onChange],
	);

	return (
		<Box xcss={styles.filterContainer}>
			<Box as="span">{filterLabel}</Box>
			<Box xcss={styles.selectContainer}>
				<Select<SelectOption>
					inputId="recently-updated-filter"
					value={selectedOption}
					options={options}
					onChange={handleChange}
					aria-label={filterLabel}
					isSearchable={false}
					menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
					menuPosition="fixed"
				/>
			</Box>
		</Box>
	);
}
